$(document).ready(function() {

	function categoryScroll(){
		setTimeout(function () {
			if($('body').hasClass('category-page')){
				if($('#category .catalog-banner').length>0){

					if ((window.location.href.indexOf("?ocf") > -1) || (window.location.href.indexOf("/sort") > -1)) {
						$('html').animate({
								scrollTop: $(".catalog-main-title").offset().top - $('#header').height()
							},1200 //speed
						);
					}
				}
			}
		},1000);
	}

	function inputTel(){
		$( '[type="tel"]' ).inputmask( '+40-99-999-9999' );
	}

	function select(){
		$( '.js-select' ).select2({
			language: 'en',
			width: '100%',
			minimumResultsForSearch: -1,
		});
	}

	function select2(){
		var dropdownParent = $('.catalog-sort');
		$( '.js-select2' ).select2({
			language: 'en',
			width: '100%',
			minimumResultsForSearch: -1,
			dropdownParent: dropdownParent,
			dropdownPosition: 'below',
		});
	}

	function search() {
		const btn = $('.js-search');
		const btnClear = $('.js-search-close');
		const input = $('#search');
		const inputBox = $('.header-search-box');
		const resultBox = $('.header-search-result');
		btn.click(function () {
			$(this).parents('form').submit();
		});
		btnClear.click(function () {
			input.val('');
			inputBox.removeClass('active');
			resultBox.fadeOut();
		});
		input.on('keyup',function () {
			if (input.val().length > 0) {
				inputBox.addClass('active');
				resultBox.fadeIn(300);
			} else {
				inputBox.removeClass('active');
				resultBox.fadeOut(300);
			}
		});
		$(document).mouseup(function (e){
			if (!resultBox.is(e.target) && resultBox.has(e.target).length === 0) {
				resultBox.fadeOut(300);
				inputBox.removeClass('active');
			}
		});
	}

	function menu() {
		const btn = $('.js-menu-btn');
		const menu = $('.js-menu');
		const overlay = $('.js-overlay');
		const close = $('.js-menu-close');
		const menuSub = $('.menu-item--sub');
		const closeSub = $('.js-submenu-close');

		btn.click(function () {
			menu.addClass('active');
			overlay.fadeIn();
			$('body').addClass('overflow');
		});

		function menuClose(){
			menu.removeClass('active');
			menuSub.removeClass('active');
			overlay.fadeOut();
			close.removeClass('sub-active');
			$('.menu-submenu').removeClass('active');
			$('.menu-submenu-item').removeClass('active');
			$('body').removeClass('overflow');
		}

		overlay.click(function () {
			menuClose();
		});

		close.click(function () {
			menuClose();
		});

		menuSub.click(function () {
			menuSub.removeClass('active');
			$(this).addClass('active');
			close.addClass('sub-active');
			$('.menu-submenu-item').removeClass('active');
			$('.menu-submenu').addClass('active');
			let item = $(this).data('submenu');
			$('[data-submenu-item="'+item+'"]').addClass('active');
		});

		closeSub.click(function () {
			close.removeClass('sub-active');
			$('.menu-submenu').removeClass('active');
			menuSub.removeClass('active');
			setTimeout(function () {
				$('.menu-submenu-item').removeClass('active');
			},300);
		});

		menuSub.each(function () {
			let title = $(this).children('.menu-item-link').text();
			let itemNum= $(this).data('submenu');
			$('[data-submenu-item="'+itemNum+'"]').find('.menu-submenu-title').text(title);
		});
	}

	function footerMenu(){
		const btn = $('.footer-item-title');
		btn.click(function () {
			if ($(window).width() < 1250) {
				const parent = $(this).parents('.footer-item');
				parent.toggleClass('active');
				parent.find('.footer-item-box').slideToggle();
			}
		});
	}

	function setInput() {
		$( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea')
			.each(function() {
				if ($(this).val() !== '') {
					$(this).parent().addClass('filled');
				}
			})
			.on('focus',function() {
				$(this).parent().removeClass('filled');
			})
			.on('blur',function() {
				if ($(this).val() !== '' ) {
					$(this).parent().addClass('filled');
				} else {
					$(this).parent().removeClass('filled');
				}
			});
	}

	function textareaHeight() {
		$("textarea").each(function () {
			this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
		}).on("input", function () {
			this.style.height = "auto";
			this.style.height = (this.scrollHeight) + "px";
		});
	}

	function fancy(){
		$( '[data-fancybox]' ).fancybox({
			closeExisting: true,
			animationEffect: 'fade',
			touch: false,
			buttons: [
				"slideShow",
				"close"
			],
			smallBtn: false,
		});
		$( '[data-fancybox-btn]' ).fancybox({
			closeExisting: true,
			animationEffect: 'fade',
			touch: false,
			buttons: false,
			smallBtn: true,
		});
	}

	function cookies() {
		const btnClose = $('.js-cookies-close');
		const cookieWindow = $('.js-cookies');

		btnClose.click(function (e) {
			e.preventDefault();
			cookieWindow.slideUp();
		});
	}

	function ontop(){
		var btn = $('.js-ontop');
		$(window).scroll(function () {
			var scroll = $(window).scrollTop();
			if (scroll >= 500) {
				btn.addClass('active');
			} else {
				btn.removeClass('active');
			}
		});
		btn.on('click',function() {
			$('html, body').animate({scrollTop: 0},500);
			return false;
		});
	}

	function sliders(){
		let sliders = document.querySelectorAll(".swiper");
		if (sliders) {
			for (let e = 0; e < sliders.length; e++) {
				let t = sliders[e];
				if (!t.classList.contains("swiper-bild")) {
					let e = t.children;
					if (e) for (let t = 0; t < e.length; t++) {
						e[t].classList.add("swiper-slide")
					}
					let l = t.innerHTML, o = document.createElement("div");
					if (o.classList.add("swiper-wrapper"), o.innerHTML = l, t.innerHTML = "", t.appendChild(o), t.classList.add("swiper-bild"), t.classList.contains("_swiper_scroll")) {
						let e = document.createElement("div");
						e.classList.add("swiper-scrollbar"), t.appendChild(e)
					}
				}
			}
		}

		let mainSlider = new Swiper(".banner-slider", {
			observer: !0,
			observeParents: !0,
			slidesPerView: "auto",
			spaceBetween: 0,
			autoHeight: !1,
			speed: 800,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			pagination: {el: ".banner-paggination", clickable: !0},
			navigation: {nextEl: ".banner-arrow-next", prevEl: ".banner-arrow-prev"},
			breakpoints: {320: {slidesPerView: "auto", spaceBetween: 20}, 768: {slidesPerView: "auto", spaceBetween: 0}}
		}), sliderMainCatalog = new Swiper(".maincatalog-slider", {
			observer: !0,
			observeParents: !0,
			slidesPerView: "auto",
			spaceBetween: 0,
			autoHeight: !1,
			speed: 800,
			mousewheel: !0,
			scrollbar: {el: ".maincatalog-scrollbar",draggable: true,}
		}), sliderProduce = new Swiper(".produce-slider", {
			observer: !0,
			observeParents: !0,
			slidesPerView: "auto",
			spaceBetween: 0,
			autoHeight: !1,
			speed: 800,
			mousewheel: !0,
			scrollbar: {el: ".produce-scrollbar",draggable: true,}
		}), prodSlider = new Swiper(".prodslider-slider", {
			observer: !0,
			observeParents: !0,
			slidesPerView: "auto",
			spaceBetween: 0,
			autoHeight: !1,
			speed: 800,
			mousewheel: !0,
			loop: true,
			navigation: {nextEl: ".prodslider-arrow-next", prevEl: ".prodslider-arrow-prev"},
		}),
			prodPreview = new Swiper(".js-prod-slider-big", {
				observer: !0,
				observeParents: !0,
				slidesPerView: "auto",
				spaceBetween: 0,
				autoHeight: !1,
				speed: 800,
				mousewheel: !0,
				loop: false,
		}),
			prodPreviewSmall = new Swiper(".js-prod-slider-small", {
				observer: !0,
				observeParents: !0,
				slidesPerView: 4,
				spaceBetween: 0,
				autoHeight: !1,
				speed: 800,
				mousewheel: !0,
				loop: false,
				slideToClickedSlide: true,
				slidesPerGroup: 1,
				slideActiveClass: 'active',
				centeredSlides: true,
				navigation: {nextEl: ".js-prod-slider-next", prevEl: ".js-prod-slider-prev"},
		});

		prodPreview.on('slideChange', function (e) {
			prodPreviewSmall.slideToLoop(prodPreview.activeIndex, 800);
		});
		prodPreviewSmall.on('slideChange', function (e) {
			prodPreview.slideToLoop(prodPreviewSmall.activeIndex, 800);
		});

		const compareItem = $('.js-compare-slider .compare-slider-item');
		const compareInfoItem = $('.js-compare-info-slider .compare-slider-item');
		//console.log(compareItem.length);

		if($(window).width() >= 768){
			if (compareItem.length > 2) {
				$('.compare-box').addClass('active');
				let compSlider = new Swiper(".js-compare-slider", {
					observer: !0,
					observeParents: !0,
					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: !1,
					speed: 800,
					mousewheel: !0,
					loop: false,
					breakpoints: {
						750: {
							slidesPerView: 2,
						},
					},
					navigation: {nextEl: ".compare-slider-arrow-next", prevEl: ".compare-slider-arrow-prev"},
				}), compInfoSlider = new Swiper(".js-compare-info-slider", {
					observer: !0,
					observeParents: !0,
					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: !1,
					speed: 800,
					mousewheel: !0,
					loop: false,
					breakpoints: {
						750: {
							slidesPerView: 2,
						},
					}
				});
				compSlider.on('slideChange', function (e) {
					compInfoSlider.slideToLoop(compSlider.activeIndex, 800);
				});
				compInfoSlider.on('slideChange', function (e) {
					compSlider.slideToLoop(compInfoSlider.activeIndex, 800);
				});
			}
		}else{
			if (compareItem.length >= 2) {
				$('.compare-box').addClass('active');
				let compSlider = new Swiper(".js-compare-slider", {
					observer: !0,
					observeParents: !0,
					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: !1,
					speed: 800,
					mousewheel: !0,
					loop: false,
					breakpoints: {
						750: {
							slidesPerView: 2,
						},
					},
					navigation: {nextEl: ".compare-slider-arrow-next", prevEl: ".compare-slider-arrow-prev"},
				}), compInfoSlider = new Swiper(".js-compare-info-slider", {
					observer: !0,
					observeParents: !0,
					slidesPerView: 1,
					spaceBetween: 0,
					autoHeight: !1,
					speed: 800,
					mousewheel: !0,
					loop: false,
					breakpoints: {
						750: {
							slidesPerView: 2,
						},
					}
				});
				compSlider.on('slideChange', function (e) {
					compInfoSlider.slideToLoop(compSlider.activeIndex, 800);
				});
				compInfoSlider.on('slideChange', function (e) {
					compSlider.slideToLoop(compInfoSlider.activeIndex, 800);
				});
			}
		}


		if (window.innerWidth < 1250) {
			let bigCatalogSlider =  new Swiper(".bigcatalog-slider", {
				observer: !0,
				observeParents: !0,
				slidesPerView: "auto",
				spaceBetween: 0,
				autoHeight: !1,
				speed: 800
			});
		}
		if (window.innerWidth < 1440) {
			let bigCatalogSlider =  new Swiper(".promo-slider", {
				observer: !0,
				observeParents: !0,
				slidesPerView: "auto",
				spaceBetween: 0,
				autoHeight: !1,
				speed: 800,
				scrollbar: {el: ".promo-scrollbar",draggable: true,}
			});
			let blogMoreSlider = new Swiper(".blogmore-slider", {
				observer: !0,
				observeParents: !0,
				slidesPerView: "auto",
				spaceBetween: 0,
				autoHeight: !1,
				speed: 800,
				mousewheel: !0,
				loop: false,
			});
		}
		if (window.innerWidth < 750) {
			let bigProdSlider =  new Swiper(".prodcatalog-slider", {
				observer: !0,
				observeParents: !0,
				slidesPerView: "auto",
				spaceBetween: 0,
				autoHeight: !1,
				speed: 800,
			});
		}
	}

	function tabs() {
		const tabs = $('.js-tabs');
		const tabBtn = tabs.find('.tab-item');
		const tabContent = tabs.find('.tab-content-item');
		const tabOpened = 1;

		tabBtn.eq(tabOpened-1).addClass('active');
		tabContent.eq(tabOpened-1).addClass('active');
		tabBtn.click(function () {
			tabBtn.removeClass('active');
			$(this).addClass('active');
			tabContent.removeClass('active');
			tabContent.eq($(this).index()).addClass('active');
		});
	}

	function comparisonWindow() {
		const btn = $('.js-comparison-pop-btn');
		const pop = $('.js-comparison-pop');
		const close = $('.js-comparison-pop-close');

		btn.click(function (e) {
			e.preventDefault();
			pop.fadeIn();
		});

		close.click(function () {
			pop.fadeOut();
		});

		$('body').on('click','.js-comparison-pop-remove',function () {
			$(this).parents('.comparison-pop-item').remove();
		});

	}

	function dropdownMenu() {
		const menu = $('.js-dropmenu');
		const menuClose = $('.js-dropmenu-close');
		const btn = $('.js-dropmenu-btn');

		function closeDrop(){
			menu.removeClass('active');
			btn.removeClass('opened');
			$('body').removeClass('overflow');
		}

		btn.click(function (e) {
			e.preventDefault();
			if ($(this).hasClass('opened')) {
				closeDrop();
			} else {
				btn.removeClass('opened');
				menu.removeClass('active');
				const menuNum = $(this).data('drop');
				$('.js-dropmenu[data-dropmenu="'+menuNum+'"]').addClass('active');
				$('body').addClass('overflow');
				$(this).addClass('opened');
			}
		});

		menuClose.click(function () {
			closeDrop();
		});
	}

	function rating() {
		const btn = $('.js-rating .rating-item');
		btn.click(function () {
			$(this).parents('.js-rating').find('.rating-input').val($(this).index()+1);
			btn.removeClass('active');
			for (i=0;i<=$(this).index();i++) {
				btn.eq(i).addClass('active');
			}
		});
		btn.hover(
			function() {
				btn.removeClass('hovered');
				for (i=0;i<=$(this).index();i++) {
					btn.eq(i).addClass('hovered');
				}
			}, function() {
				btn.removeClass('hovered');
			}
		);
	}

	function FAQ() {
		const faq = $('.js-faq');
		if (faq) {
			const btn = faq.find('.faq-head');
			faq.find('.faq-item').each(function(){
				if ($(this).hasClass('active')) {
					$(this).find('.faq-text').slideDown();
				}
			});
			btn.on('click',function(){
				const item = $(this).parents('.faq-item');
				item.toggleClass('active');
				item.find('.faq-text').slideToggle();
			});
		}
	}

	function cariere() {
		const btn = $('.js-cariere .cariere-item .cariere-info-head');
		btn.click(function () {
			$(this).next('.cariere-info-box').slideToggle();
			$(this).find('.icon-arrow-right').toggleClass('active');
		});
	}

	function shops(){
		if ($('.js-map').length>0) {
			var marker;
			$(function () {
				$('.js-map').each(function () {
					initMap(this)
				})
			})
			function initMap(obj) {
				if ($(obj).data('lat') != '' && $(obj).data('lng') != '') {
					var map = new google.maps.Map($(obj)[0], {
						center: {lat: $(obj).data('lat'), lng: $(obj).data('lng')},
						zoom: 10,
					});
					marker = new google.maps.Marker({
						position: {lat: $(obj).data('lat'), lng: $(obj).data('lng')},
						map: map
					});
				}
			}
		}
	}

	function quantity() {
		$("body").on("click",".js-quantity-button", function () {
			var $button = $(this);
			var oldValue = $button.parents('.js-quantity').find('.js-quantity-input').val();

			if ($button.hasClass('js-quantity-button--plus')) {
				var newVal = parseFloat(oldValue) + 1;
			} else {
				if (oldValue > 0) {
					var newVal = parseFloat(oldValue) - 1;
				} else {
					newVal = 0;
				}
			}
			$button.parents('.js-quantity').find('.js-quantity-input').val(newVal).change();
		});
		$('.js-quantity-input').on('keyup keypress', function(e) {
			if (e.keyCode == 8 || e.keyCode == 46) {}
			else
			{
				var letters='1234567890';
				return (letters.indexOf(String.fromCharCode(e.which))!=-1);
			}
		});
	}

	function cartHead(){
		const titleFirst = $('.cart-head span:first');
		if ($(window).width() < 1440) {
			titleFirst.css('width',128 + $('.cart-text').width());
		} else {
			titleFirst.removeAttr('style');
		}
		$(window).resize(function () {
			if ($(window).width() < 1440) {
				titleFirst.css('width',128 + $('.cart-text').width());
			} else {
				titleFirst.removeAttr('style');
			}
		});
	}

	function promotionsHeight() {
		const title = $('.promotions-item-title');
		const text = $('.promotions-item-text');
		if (title.length > 0) {
			title.matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});
		}
		if (text.length > 0) {
			text.matchHeight({
				byRow: true,
				property: 'height',
				target: null,
				remove: false
			});
		}
	}

	function filter() {
		const filter = $('.js-filter');
		const filterBtn = $('.js-filter-btn');
		const filterClose = $('.js-filter-close');

		filterBtn.click(function () {
			filter.addClass('active');
		});
		filterClose.click(function () {
			filter.removeClass('active');
		});
	}

	function markCurrentLink(){
		$('a[href="'+location.href+'"]').addClass('current');
	}
	markCurrentLink();
	categoryScroll();
	inputTel();
	/*search();*/
	menu();
	footerMenu();
	select();
	select2();
	setInput();
	textareaHeight();
	fancy();
	cookies();
	ontop();
	sliders();
	tabs();
	comparisonWindow();
	dropdownMenu();
	rating();
	FAQ();
	cariere();
	shops();
	quantity();
	cartHead();
	promotionsHeight();
	filter();
});
